import { render, staticRenderFns } from "./AppVersionManage.vue?vue&type=template&id=6dfe8cce&scoped=true"
import script from "./AppVersionManage.vue?vue&type=script&lang=js"
export * from "./AppVersionManage.vue?vue&type=script&lang=js"
import style0 from "./AppVersionManage.vue?vue&type=style&index=0&id=6dfe8cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfe8cce",
  null
  
)

export default component.exports